import React from 'react';
const Footer = () => {
    return ( 
        <div className="footer">
           
          <h1>Shazi™</h1>
          

        </div>
    );
}
 
export default Footer;